import { render } from "./front.vue?vue&type=template&id=6d1d5c5e&scoped=true"
import script from "./front.vue?vue&type=script&lang=js"
export * from "./front.vue?vue&type=script&lang=js"

import "./front.vue?vue&type=style&index=0&id=6d1d5c5e&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1d5c5e"]])

export default __exports__